__turbopack_context__.v({
  "container": "production-requirements-module-scss-module__SzqZGa__container",
  "error-message": "production-requirements-module-scss-module__SzqZGa__error-message",
  "header": "production-requirements-module-scss-module__SzqZGa__header",
  "header__country-selector": "production-requirements-module-scss-module__SzqZGa__header__country-selector",
  "header__dropdown-skeleton": "production-requirements-module-scss-module__SzqZGa__header__dropdown-skeleton",
  "header__year-selector": "production-requirements-module-scss-module__SzqZGa__header__year-selector",
  "note-wrapper": "production-requirements-module-scss-module__SzqZGa__note-wrapper",
  "production-table": "production-requirements-module-scss-module__SzqZGa__production-table",
  "production-table--sticky": "production-requirements-module-scss-module__SzqZGa__production-table--sticky",
  "requirements-wrapper": "production-requirements-module-scss-module__SzqZGa__requirements-wrapper",
});
